import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const RectangleHorizontalTwoLinesIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M2 8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V8ZM20 8L4 8V16H20V8Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M6.00726 13.7275C6.00726 13.1753 6.45498 12.7275 7.00726 12.7275H11.0223C11.5746 12.7275 12.0223 13.1753 12.0223 13.7275 12.0223 14.2798 11.5746 14.7275 11.0223 14.7275H7.00726C6.45498 14.7275 6.00726 14.2798 6.00726 13.7275zM6.00726 10.4546C6.00726 9.90231 6.45498 9.45459 7.00726 9.45459H15.0323C15.5846 9.45459 16.0323 9.90231 16.0323 10.4546 16.0323 11.0069 15.5846 11.4546 15.0323 11.4546H7.00726C6.45498 11.4546 6.00726 11.0069 6.00726 10.4546z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
